import React from 'react'
import { connect } from 'react-redux'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsSrvgItem from "./SetsSrvgItem"
import { isEmpty } from 'lodash'
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsForm from './SettingsForm'

class SetsSrvg extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('srvg');
    this.props.fetchSets('srvm');
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'srvg'

  newItem = {
    srvg_desc: '',
    srvg_srvm_id: 1,
    srvg_sort: 0,
    srvg_active: 1,
    srvg_prs: 0,
    srvg_subtotal: 0
  }

  render() {
    if(isEmpty(this.props.srvgs.data)
      || isEmpty(this.props.srvms.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const srvgs = this.props.srvgs.data;
    const { search, sort } = this.props.srvgs;
    const srvms = this.props.srvms.data;
    const { data, errors } = this.state;

    var fltrSrvgs = [];
    for(var key in srvgs){
      if(srvgs.hasOwnProperty(key)){
        const active = srvgs[key].srvg_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + srvgs[key].srvg_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrSrvgs.push(srvgs[key]);
        }
      }
    }

    const srtSrvgs = fltrSrvgs.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.srvg_id < b.srvg_id)
         return sort.asc ? -1 : 1
      if(a.srvg_id > b.srvg_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedSrvgs = srtSrvgs ? srtSrvgs.map(srvg =>
      <SetsSrvgItem key={srvg.srvg_id}
        data={srvg}
        srvms={srvms}
      />
    ) : [];

    var srvmsOpt = [];
    for (key in srvms){
      if(srvms.hasOwnProperty(key) && (srvms[key].srvm_active === 1
        || srvms[key].srvm_id === data.srvg_srvm_id)) {
        srvmsOpt.push({value:srvms[key].srvm_id,label:srvms[key].srvm_desc});
      }
    }
    srvmsOpt.sort(sortOpts);

    const subtotalOpt = [
      {value: 0, label: 'Нет'},
      {value: 1, label: 'Надбавка'},
      {value: 2, label: 'Налог'}
    ];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.srvg_desc}
              name="srvg_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <Select
            clearable={false}
            options={srvmsOpt}
            value={data.srvg_srvm_id}
            onChange={e => this.updateSelect(e,'srvg_srvm_id')}
            placeholder="Главная группа услуг"
          />
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.srvg_sort}
              name="srvg_sort"
              onChange={this.updateInput}
              placeholder="Сортировка"
            />
          </div>
        </td>
        <td>
          <Select
            clearable={false}
            options={subtotalOpt}
            value={data.srvg_subtotal}
            onChange={e => this.updateSelect(e,'srvg_subtotal')}
            placeholder="После подитога"
          />
        </td>
        <td>
          <input
            type="checkbox"
            checked={data.srvg_prs}
            name="srvg_prs"
            onChange={this.handleChBox}
          />
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка групп услуг</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrSrvgs.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-5" onClick={() => {this.handleSort('srvg_desc')}}>Название</th>
              <th className="col-sm-4" onClick={() => {this.handleSort('srvg_srvm_id')}}>Главная группа услуг</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvg_sort')}}>Сортировка</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvg_subtotal')}}>После подитога</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvg_prs')}}>Показывать в ПРС</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedSrvgs}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    srvgs: store.srvgs,
    srvms: store.srvms
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsSrvg);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvg.js